import React, { useState, useEffect } from 'react';
import { servicioService, productoService } from '../services/api';
import '../styles/Inventario.css';

const Inventario = () => {
  const [vista, setVista] = useState('servicios'); // 'servicios' o 'productos'
  const [servicios, setServicios] = useState([]);
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [itemSeleccionado, setItemSeleccionado] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    categoria: '',
    precio_base: '',
    precio: '',
    unidad: '',
    stock_actual: 0,
    stock_minimo: 0,
    proveedor: ''
  });

  useEffect(() => {
    cargarDatos();
  }, [vista]);

  const cargarDatos = async () => {
    try {
      if (vista === 'servicios') {
        const response = await servicioService.getAll();
        setServicios(response.data);
      } else {
        const response = await productoService.getAll();
        setProductos(response.data);
      }
    } catch (error) {
      console.error('Error al cargar datos:', error);
    } finally {
      setLoading(false);
    }
  };

  const abrirModal = (item = null) => {
    if (item) {
      setItemSeleccionado(item);
      setFormData({
        nombre: item.nombre,
        descripcion: item.descripcion || '',
        categoria: item.categoria || '',
        precio_base: item.precio_base || '',
        precio: item.precio || '',
        unidad: item.unidad || '',
        stock_actual: item.stock_actual || 0,
        stock_minimo: item.stock_minimo || 0,
        proveedor: item.proveedor || ''
      });
    } else {
      setItemSeleccionado(null);
      setFormData({
        nombre: '',
        descripcion: '',
        categoria: '',
        precio_base: '',
        precio: '',
        unidad: '',
        stock_actual: 0,
        stock_minimo: 0,
        proveedor: ''
      });
    }
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setItemSeleccionado(null);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (vista === 'servicios') {
        if (itemSeleccionado) {
          await servicioService.update(itemSeleccionado.id, formData);
        } else {
          await servicioService.create(formData);
        }
      } else {
        if (itemSeleccionado) {
          await productoService.update(itemSeleccionado.id, formData);
        } else {
          await productoService.create(formData);
        }
      }
      cargarDatos();
      cerrarModal();
    } catch (error) {
      console.error('Error al guardar:', error);
      alert(error.response?.data?.error || 'Error al guardar');
    }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm(`¿Estás seguro de eliminar este ${vista === 'servicios' ? 'servicio' : 'producto'}?`)) return;

    try {
      if (vista === 'servicios') {
        await servicioService.delete(id);
      } else {
        await productoService.delete(id);
      }
      cargarDatos();
    } catch (error) {
      console.error('Error al eliminar:', error);
      alert(error.response?.data?.error || 'Error al eliminar');
    }
  };

  const ajustarStock = async (producto, tipo) => {
    const cantidad = prompt(`Cantidad a ${tipo === 'entrada' ? 'agregar' : 'quitar'}:`);
    if (!cantidad || isNaN(cantidad)) return;

    try {
      await productoService.ajustarStock(producto.id, parseFloat(cantidad), tipo);
      cargarDatos();
    } catch (error) {
      console.error('Error al ajustar stock:', error);
      alert(error.response?.data?.error || 'Error al ajustar stock');
    }
  };

  if (loading) {
    return <div className="loading">Cargando inventario...</div>;
  }

  const items = vista === 'servicios' ? servicios : productos;

  return (
    <div className="inventario-container">
      <div className="page-header">
        <h1>Inventario</h1>
        <button className="btn btn-primary" onClick={() => abrirModal()}>
          + Nuevo {vista === 'servicios' ? 'Servicio' : 'Producto'}
        </button>
      </div>

      <div className="vista-tabs">
        <button
          className={`tab ${vista === 'servicios' ? 'active' : ''}`}
          onClick={() => setVista('servicios')}
        >
          📋 Servicios
        </button>
        <button
          className={`tab ${vista === 'productos' ? 'active' : ''}`}
          onClick={() => setVista('productos')}
        >
          📦 Productos
        </button>
      </div>

      {items.length === 0 ? (
        <div className="empty-state">
          <p>No hay {vista} registrados</p>
          <button className="btn btn-primary" onClick={() => abrirModal()}>
            Agregar primer {vista === 'servicios' ? 'servicio' : 'producto'}
          </button>
        </div>
      ) : (
        <div className="items-grid">
          {items.map(item => (
            <div key={item.id} className="item-card">
              <div className="item-header">
                <h3>{item.nombre}</h3>
                {item.categoria && (
                  <span className="categoria-badge">{item.categoria}</span>
                )}
              </div>

              {item.descripcion && (
                <p className="item-descripcion">{item.descripcion}</p>
              )}

              <div className="item-info">
                {vista === 'servicios' && item.precio_base && (
                  <p><strong>Precio base:</strong> ${parseFloat(item.precio_base).toFixed(2)}</p>
                )}
                {vista === 'productos' && item.precio && (
                  <p><strong>Precio:</strong> ${parseFloat(item.precio).toFixed(2)}</p>
                )}
                {item.unidad && (
                  <p><strong>Unidad:</strong> {item.unidad}</p>
                )}
                {vista === 'productos' && (
                  <>
                    <p>
                      <strong>Stock:</strong>
                      <span className={item.stock_actual <= item.stock_minimo ? 'stock-bajo' : ''}>
                        {item.stock_actual}
                      </span>
                      {item.stock_actual <= item.stock_minimo && ' ⚠️'}
                    </p>
                    {item.proveedor && (
                      <p><strong>Proveedor:</strong> {item.proveedor}</p>
                    )}
                  </>
                )}
              </div>

              <div className="item-actions">
                {vista === 'productos' && (
                  <>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => ajustarStock(item, 'entrada')}
                    >
                      + Stock
                    </button>
                    <button
                      className="btn btn-warning btn-sm"
                      onClick={() => ajustarStock(item, 'salida')}
                    >
                      - Stock
                    </button>
                  </>
                )}
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => abrirModal(item)}
                >
                  Editar
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleEliminar(item.id)}
                >
                  Eliminar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {modalAbierto && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>
              {itemSeleccionado ? 'Editar' : 'Nuevo'}{' '}
              {vista === 'servicios' ? 'Servicio' : 'Producto'}
            </h2>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  placeholder="Nombre del item"
                />
              </div>

              <div className="form-group">
                <label>Descripción</label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  rows="2"
                  placeholder="Descripción detallada"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Categoría</label>
                  <input
                    type="text"
                    name="categoria"
                    value={formData.categoria}
                    onChange={handleChange}
                    placeholder="Categoría"
                  />
                </div>

                <div className="form-group">
                  <label>Unidad</label>
                  <input
                    type="text"
                    name="unidad"
                    value={formData.unidad}
                    onChange={handleChange}
                    placeholder="m², kg, unidad, etc."
                  />
                </div>
              </div>

              {vista === 'servicios' && (
                <div className="form-group">
                  <label>Precio Base</label>
                  <input
                    type="number"
                    name="precio_base"
                    value={formData.precio_base}
                    onChange={handleChange}
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                  />
                </div>
              )}

              {vista === 'productos' && (
                <>
                  <div className="form-group">
                    <label>Precio</label>
                    <input
                      type="number"
                      name="precio"
                      value={formData.precio}
                      onChange={handleChange}
                      min="0"
                      step="0.01"
                      placeholder="0.00"
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Stock Actual</label>
                      <input
                        type="number"
                        name="stock_actual"
                        value={formData.stock_actual}
                        onChange={handleChange}
                        min="0"
                      />
                    </div>

                    <div className="form-group">
                      <label>Stock Mínimo</label>
                      <input
                        type="number"
                        name="stock_minimo"
                        value={formData.stock_minimo}
                        onChange={handleChange}
                        min="0"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Proveedor</label>
                    <input
                      type="text"
                      name="proveedor"
                      value={formData.proveedor}
                      onChange={handleChange}
                      placeholder="Nombre del proveedor"
                    />
                  </div>
                </>
              )}

              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  {itemSeleccionado ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Inventario;
